import _styled from "styled-components";
import React, {useCallback, useMemo, useRef, useState} from "react";
import ReactCrop from "../../../../__snowpack__/pkg/react-image-crop.js";
import "../../../../__snowpack__/pkg/react-image-crop/dist/ReactCrop.css.proxy.js";
import {execFn, remToPixel} from "../../../common/generic-react.functions.js";
import Button from "../../atoms/button/button.component.js";
import Modal from "../../atoms/modal/modal.component.js";
import {CropImageContainer} from "./crop-image.styles.js";
const pixelRatio = window.devicePixelRatio || 1;
function CropImage({
  show = false,
  disabled,
  image,
  file,
  onCancel,
  onComplete
}) {
  const [crop, setCrop] = useState({
    x: 0,
    y: 0
  });
  const [imageRef, setImageRef] = useState(null);
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [finalImage, setFinalImage] = useState("");
  const modalRef = useRef(null);
  const getCroppedImg = useCallback((img, completedCrop) => {
    const canvas = document.createElement("canvas");
    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;
    const {
      x = 1,
      y = 1
    } = completedCrop;
    const cropWidth = Math.round(completedCrop?.width ?? 0);
    const cropHeight = Math.round(completedCrop?.height ?? 0);
    canvas.width = cropWidth * pixelRatio;
    canvas.height = cropHeight * pixelRatio;
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, x * scaleX, y * scaleY, cropWidth * scaleX, cropHeight * scaleY, 0, 0, cropWidth, cropHeight);
    }
    return new Promise((resolve) => {
      const fileB64 = canvas.toDataURL(file?.type || "image/jpeg", 1);
      resolve(fileB64);
    });
  }, [file?.type]);
  const onCompleteCrop = useCallback((completedCrop) => {
    if (imageRef && completedCrop.width && completedCrop.height) {
      getCroppedImg(imageRef, completedCrop).then((result) => {
        setFinalImage(result);
      });
    }
  }, [getCroppedImg, imageRef]);
  const onImageLoaded = useCallback((img) => {
    setImageRef(img);
    const heightActions = 60;
    const space = remToPixel(2);
    if (img.width >= img.height) {
      setWidth(`${img.width + space}px`);
      setHeight(`${img.height + heightActions + space}px`);
    } else {
      setWidth("auto");
      setHeight(`${img.height + heightActions + space}px`);
    }
  }, []);
  const closeModal = useCallback(() => {
    execFn(onCancel);
    modalRef.current?.hide();
  }, [onCancel]);
  const completeAction = useCallback(() => {
    execFn(onComplete, finalImage);
    modalRef.current?.hide();
  }, [finalImage, onComplete]);
  const actionButtons = useMemo(() => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    onClick: closeModal,
    color: "var(--tertiaryColor)"
  }, "Cancel"), /* @__PURE__ */ React.createElement(Button, {
    onClick: completeAction,
    color: "var(--secondaryColor)"
  }, "Confirm")), [closeModal, completeAction]);
  return /* @__PURE__ */ React.createElement(CropImageContainer, null, /* @__PURE__ */ React.createElement(Modal, {
    ref: modalRef,
    show,
    dismiss: false,
    persistent: true,
    actions: actionButtons,
    width,
    height
  }, /* @__PURE__ */ React.createElement(_StyledReactCrop, {
    src: image,
    crop,
    keepSelection: true,
    disabled,
    onImageLoaded,
    onChange: setCrop,
    onComplete: onCompleteCrop
  })));
}
export default /* @__PURE__ */ React.memo(CropImage);
var _StyledReactCrop = _styled(ReactCrop).withConfig({
  displayName: "crop-imagecomponent___StyledReactCrop",
  componentId: "sc-5nyji0-0"
})({
  display: "flex",
  justifyContent: "center"
});
